import { createContext } from 'react';

import { ARC_DEFAULT_VALUE_COLOR } from '../constants.js';

export const GaugeChartBaseColorContext = createContext<string>(
  ARC_DEFAULT_VALUE_COLOR,
);
